function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.167 21.667c-.534 0-1-.2-1.4-.6-.4-.4-.6-.867-.6-1.4V2.333c0-.533.2-1 .6-1.4.4-.4.866-.6 1.4-.6h22.666c.534 0 1 .2 1.4.6.4.4.6.867.6 1.4v17.334c0 .533-.2 1-.6 1.4-.4.4-.866.6-1.4.6H2.167zM13.5 11.6L2.167 4.167v15.5h22.666v-15.5L13.5 11.6zm0-2l11.2-7.267H2.333L13.5 9.6zM2.167 4.167V2.333v17.334-15.5z",
  fill: "currentColor"
});
var SvgHelpEmail = function SvgHelpEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 22",
    fill: "none"
  }, props), _ref);
};
export default SvgHelpEmail;